"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const noop_1 = __importDefault(require("lodash/noop"));
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_buttons_1 = require("@hotelplan/components.common.buttons");
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const libs_context_ios_scroll_block_1 = require("@hotelplan/libs.context.ios-scroll-block");
const DEFAULT_ACCORDION_ICON_NAME = 'chevron-left';
const AccordionItemWrap = styled_components_1.default.div(({ theme: { space } }) => ({
    display: 'flex',
    flexDirection: 'column',
    '.accordionButtonWrap': {
        padding: `0 ${space[3]}`,
    },
    '.accordionContent': {
        display: 'none',
    },
    '.accordionContent.scrollable': {
        overflow: 'auto',
    },
    '.accordionContent.active': {
        display: 'block',
    },
}));
const DefaultAccordionButton = (0, styled_components_1.default)(components_common_buttons_1.Button).attrs({
    variant: 'accordionBtn',
})(({ theme: { colors } }) => ({
    borderTop: '1px solid',
    borderBottom: '1px solid',
    borderColor: colors.lightGreyFirst,
    marginBottom: '-1px',
    transition: 'none',
}));
const AccordionIcon = (0, styled_components_1.default)(components_common_icon_1.Icon).attrs({
    className: 'chevron',
})(({ theme: { transition, space } }) => ({
    transition: transition.fast,
    height: '12px',
    marginLeft: space[1],
}), ({ active }) => ({
    transform: `${active ? 'rotate(-90deg)' : 'rotate(90deg)'}`,
}));
const AccordionItem = ({ title, active, onOpen = noop_1.default, onClose = noop_1.default, children, className, testId, customIcon, scrollable = false, AccordionButtonComponent = DefaultAccordionButton, }) => {
    const activeClass = active ? 'active' : '';
    const contentRef = (0, react_1.useRef)(null);
    (0, libs_context_ios_scroll_block_1.useScrollElement)(contentRef, scrollable);
    const iconName = customIcon
        ? active
            ? customIcon.activeIcon
            : customIcon.inactiveIcon || customIcon.activeIcon
        : DEFAULT_ACCORDION_ICON_NAME;
    return (react_1.default.createElement(AccordionItemWrap, { className: `accordionItem ${activeClass} ${className}` },
        react_1.default.createElement("div", { className: "accordionButtonWrap" },
            react_1.default.createElement(AccordionButtonComponent, { testId: testId, className: `accordionButton ${activeClass}`, onClick: active ? onClose : onOpen },
                title,
                react_1.default.createElement(AccordionIcon, { active: active, name: iconName }))),
        react_1.default.createElement("div", { ref: contentRef, className: `accordionContent ${activeClass} ${scrollable ? 'scrollable' : ''}` }, typeof children === 'function' ? children(active || false) : children)));
};
exports.default = AccordionItem;
//# sourceMappingURL=AccordionItem.js.map